import React, { Component } from 'react';
import '../App.css';

export default class Extras extends Component {
  
  page = '';
  componentDidUpdate() {   
    if (this.page !== window.location.pathname.split('/')[1].toLowerCase()) {
      window.scrollTo(0, 0);
      this.page = window.location.pathname.split('/')[1].toLowerCase();
    }
  }
  componentDidMount() {   
    if (this.page !== window.location.pathname.split('/')[1].toLowerCase()) {
      window.scrollTo(0, 0);
      this.page = window.location.pathname.split('/')[1].toLowerCase();
    }
  }
  
  render() {    
    switch(window.location.pathname.split('/')[1].toLowerCase()) {
      case 'about': // ============================= ABOUT =================================
        return (
          <div className="extra_div">
            <h1>ABOUT</h1>
            <br/>
            Minusthenegative is here to hear you and here to help you. It is a place of true social networking – the purpose being to share experiences so that you can grow and overcome things as a person and help people over come things you’ve already been through. It’s a place for people to help one another without insecurities, shame, or fear getting in the way. It’s you, totally open, but completely hidden. Get it?
            <br/><br/><br/>
            <strong>We work to get you help A S A P. However, we’re not perfect and ultimately, you getting help is more important than any thing else. So if you need to talk to someone urgently, here’s a list of hotlines for around the world:</strong>
            <br/><br/><br/>
            Worldwide free crisis textline: 741-741
            <br/><br/>
            –AMERICAN HELPLINES–IF URGENT PLEASE CALL 911–
            <br/><br/>
            Suicide hotline: 800-784-2433
            <br/><br/>
            Crisis Call Center: 800-273-8255 (or text ANSWER to 839863 )
            <br/><br/>
            Teen crisis intervention and counseling: 1 – 800 – 999 – 9999
            <br/><br/>
            Post-Abortion help: 1 – 800 – 5WE – CARE or 1 – 800 – 593 – 2273
            <br/><br/>
            Alateen hotline (alcoholism of your friends or family): 1 – 800 – 344 – 2666
            <br/><br/>
            Be Sober hotline: 1 – 800 – BE – SOBER
            <br/><br/>
            Attention Deficit/Hyperactivity Disorder hotline: 1 – 800 – 233 – 4050
            <br/><br/>
            Child abuse hotlines: 1 – 800 – 4 –A – CHILD or 1 – 800 – 422 – 4453
            <br/><br/>
            Cocaine hotlines: 1 – 800 – 262 – 2463 or 1 – 800 – 992 – 9239
            <br/><br/>
            Domestic violence hotlines: 1 – 800 – 799 – SAFE or 1 – 800 – 799 – 7233 or 1 – 800 – 548 – 2722 or 800 – 799 – 7233
            <br/><br/>
            Drug help: 1 – 800 – 378 – 4435
            <br/><br/>
            Eating disorder hotlines: 1 – 800 – 931 – 2237 or 1 – 888 – 236 – 1188
            <br/><br/>
            Family violence hotline: 1 – 800 – 313 – 1310
            <br/><br/>
            LGBT+ Youth hotline: 800 – 850 – 8078
            <br/><br/>
            Gay and Lesbian hotline: 1 – 888 – THE – GLNH or 1 – 888 – 843 – 4564
            <br/><br/>
            Homeless/runaway hotlines: 800 – 231 – 6946 or 1 – 800 – 621 – 4000 or 1-800-231-6946 or 1-800-621-4000
            <br/><br/>
            Help finding a therapist: 1 – 800 – THERAPIST or 1 – 800 – 843 -7274
            <br/><br/>
            Child of alcoholics hotline: 1 – 888 – 55 – 4COAS or 1 – 888 – 554 – 2627
            <br/><br/>
            Adolescent suicide hotline: 800 – 621 – 4000
            <br/><br/>
            Panic disorder hotline: 800 – 64 – PANIC
            <br/><br/>
            Pet loss support/Grief counseling: 1 – 888 – ISU – PLSH or 1 – 888 – 478 – 7574
            <br/><br/>
            Planned Parenthood: 1-800-230-PLAN
            <br/><br/>
            Pregnant & Young hotline: 1-800 550-4900
            <br/><br/>
            Rape, Abuse, and/or Incest hotlines: 1-800-656-HOPE or 1-800-656-4673
            <br/><br/>
            Self-Harm hotlines: 1-800-DONT CUT or 1-800-366-8288
            <br/><br/>
            Sexual assault hotline: 800-656-4673
            <br/><br/>
            Peer counselors: 1-800-475-TALK or 1-800-475-2855
            <br/><br/>
            LGBT+ Suicide prevention hotline: 1-800-850-8078
            <br/><br/>
            –AUSTRALIAN HELPLINES–IF URGENT PLEASE CALL 000–
            <br/><br/>
            Youth Helpline (for abuse, suicide, drug problems, etc.): 1800 55 1800
            <br/><br/>
            Parentline: 1300 30 1300
            <br/><br/>
            Child protection/Family crisis line: 1800 656 463
            <br/><br/>
            Suicide hotline: 1300 651 251
            <br/><br/>
            Beyondblue: 1300-224-636
            <br/><br/>
            –CANADIAN HELPINES–IF URGENT PLEASE CALL 911–
            <br/><br/>
            Suicide hotlines: (514) 723 4000 or 1-877-435-7170
            <br/><br/>
            Crisis hotline: 1-800-757-7766
            <br/><br/>
            Youth hotline: 1-800-668-6868 or 1-800-668-6868
            <br/><br/>
            Parentline: 1-888-603-9100
            <br/><br/>
            Sexual Assault support line: 1-800-909-7007
            <br/><br/>
            Mood Disorder Association: 1-204-786-0987
            <br/><br/>
            –AUSTRIAN HOTLINE–IF URGENT PLEASE CALL 133–
            <br/><br/>
            Crisis counseling: (00 43) 142
            <br/><br/>
            –BELGIUM HELPLINES–IF URGENT PLEASE CALL 112, 100, OR 101–
            <br/><br/>
            Support line: 106
            <br/><br/>
            Suicide hotlines: 0800-32-123 or 206
            <br/><br/>
            Crisis line: 800-5555-5522
            <br/><br/>
            Child abuse hotline: 078-15 00 20
            <br/><br/>
            –DANISH HELPLINES–IF URGENT PLEASE CALL (+45) 112 OR (+45) 1813–
            <br/><br/>
            Crisis lines: 70 201 201 or 00 800 5555 5522
            <br/><br/>
            –FRANCE HELPLINES–IF URGENT PLEASE CALL 112–
            <br/><br/>
            Suicide hotlines: (+33) (0)9 51 11 61 30 or 01 45 39 4000
            <br/><br/>
            English-speaking hotline: 01 46 21 46 46
            <br/><br/>
            Family violence hotline: 01.44.73.01.27
            <br/><br/>
            Sexual assault hotline: 0.800.05.95.95
            <br/><br/>
            –GERMAN HELPLINES–IF URGENT PLEASE CALL 112–
            <br/><br/>
            Suicide hotlines: 0800 1110 111 or 0800 1110 222
            <br/><br/>
            Youth hotline: 0800 1110 333
            <br/><br/>
            Crisis line: 800 5555 5522
            <br/><br/>
            –UK HELPLINES–IF URGENT PLEASE CALL 999–
            <br/><br/>
            Eating disorder hotline: 0845 634 1414
            <br/><br/>
            Youth eating disorder hotline: 0845 634 7650
            <br/><br/>
            B-eat (Beat Eating Disorders) Textline: 07786 20 18 20
            <br/><br/>
            Suicide hotlines: 08457 909090 or +44 1603 611311 or +44 (0) 8457 90 91 92 or 1850 60 90 90 or 1850 60 90 91
            <br/><br/>
            Anxiety/Anorexia/Bulimia hotline: 0845 120 2916
            <br/><br/>
            OCD hotline: 0845 3906232
            <br/><br/>
            Christian-based crisis hotline: 0845 658 0045
            <br/><br/>
            Suicide hotline: 08457-90-90-90
            <br/><br/>
            Manic Depression hotline: 0845 634 0540
            <br/><br/>
            –BRAZILIAN HELPLINE–IF URGENT PLEASE CALL 192–
            <br/><br/>
            Suicide hotlines: +55 51 211 2888 or 0800 5555 5522
            <br/><br/>
            Crisis line: 21-233-9191
            <br/><br/>
            –MORE INTERNATIONAL HOTLINES–IF URGENT PLEASE CONTACT YOUR LOCAL POLICE–
            <br/><br/>
            Argentina suicide hotline: 800 555 5522 or 54-0223-493-0430
            <br/><br/>
            China suicide/crisis hotlines: 800 5555 5522 or 852-2383-0000
            <br/><br/>
            Columbia suicide hotline: 800 5555 5522
            <br/><br/>
            Costa Rica suicide/crisis hotlines: 00 800 5555 5522 or 506-253-5439
            <br/><br/>
            Finland suicide hotline: 800 5555 5522
            <br/><br/>
            Hong Kong suicide hotline: 800 555 5522
            <br/><br/>
            Hungary suicide hotline: 800 555 5522
            <br/><br/>
            India suicide hotlines: 000 800 1006 614 or 92-22-307-3451
            <br/><br/>
            Ireland suicide hotlines: 800 5555 5522 or 44-0-8457-90-90-90
            <br/><br/>
            Israel suicide hotlines: 800 5555 5522 or 1201
            <br/><br/>
            Italy suicide hotlines: 800 5555 5522 or 06-705-4444
            <br/><br/>
            Japan suicide hotlines: 800 5555 5522 or 3-5286-9090
            <br/><br/>
            Luxembourg suicide hotline: 800 5555 5522
            <br/><br/>
            Malaysia suicide hotline: 800 5555 5522
            <br/><br/>
            Mexico suicide hotlines: 001 800 514 3716 or 525-510-2550
            <br/><br/>
            Netherlands suicide hotlines: 800 5555 5522 or 0900-0767
            <br/><br/>
            New Zealand suicide hotlines: 800 5555 5522 or 4-473-9739
            <br/><br/>
            Norway suicide hotline: 800 5555 5522
            <br/><br/>
            Portugal suicide hotline: 800 5555 5522
            <br/><br/>
            Philippines suicide hotline: 800 5555 5522
            <br/><br/>
            Russia suicide hotlines: 810 800 2643 1012 or 8-20-222-82-10
            <br/><br/>
            Singapore: 800 5555 5522
            <br/><br/>
            South Africa: 800 5555 5522
            <br/><br/>
            South Korea: 800 5555 5522
            <br/><br/>
            Spain: 800 5555 5522
            <br/><br/>
            Sweden: 800 5555 5522
            <br/><br/>
            Switzerland: 800 5555 5522
            <br/><br/>
            Taiwan: 800 5555 5522
            <br/><br/>
            Thailand: 800 5555 5522
            <br/><br/>
            Poland suicide hotline: 52-70-000
            <br/><br/>
            Ukraine suicide hotline: 0458-327715
            <br/><br/>
            Botswana suicide hotline: 3911270
            <br/><br/>
            Greece suicide hotline: (0) 30 210 34 17 164
            <br/><br/>
            <p className="text-muted">Version (1.10)</p>
          </div>
        );
      case 'terms': // =================================== TERMS ===================================
        return (
          <div className="extra_div">
            <h1>TERMS</h1>
            -____-
            <br/><br/><br/>
            MINUSTHENEGATIVE.COM TERMS OF USE
            <br/><br/>
            <strong>Introduction</strong>
            <br/><br/>
            These terms and conditions govern your use of the minusthenegative.com website and any associated software or applications provided by Minusthenegative LLC (the “Company”) via the website (collectively, the “Website”).   By using Wesbite, you acknowledge that you have read, understood and accept these terms and conditions in full. If you disagree with these terms and conditions or any part of these terms and conditions, please do not use this wWebsite.  [DO A GLOBAL CHANGE FROM MINUSTHE… to Website and LLC to the Company]
            <br/><br/>
            You must be at least [18] years of age to use this website. By using this website [and by agreeing to these terms and conditions] you warrant and represent that you are at least [18] years of age.]
            <br/><br/>
            <strong>License to use Website</strong>
            <br/><br/>
            Unless otherwise stated, [the Company and/or its licensors own the intellectual property rights in the website and material on the website. Subject to the license below, all these intellectual property rights are reserved.
            <br/><br/>
            You may view, download for caching purposes only, and print pages from the website for your own personal use, subject to the restrictions set out below and elsewhere in these terms and conditions.
            <br/><br/>
            You must not:
            <br/><br/>
            <ul>
              <li>republish material from this website (including republication on another website);</li>
              <li>sell, rent or sub-license material from the website;</li>
              <li>show any material from the website in public;</li>
              <li>reproduce, duplicate, copy or otherwise exploit material on this website for a commercial purpose;</li>
              <li>edit or otherwise modify any material on the website; or</li>
              <li>redistribute material from this website [except for content specifically and expressly made available for redistribution.</li>
            </ul>
            <br/>
            <strong>Acceptable use</strong>
            <br/><br/>
            You must not use this website in any way that causes, or may cause, damage to the website or impairment of the availability or accessibility of the website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
            <br/><br/>
            You must not use this website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
            <br/><br/>
            You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to this website without [Minusthenegative LLC] express written consent.
            <br/><br/>
            You must not use this website to transmit or send unsolicited commercial communications.
            <br/><br/>
            You must not use this website for any purposes related to marketing without [Minusthenegative LLC] express written consent.
            <br/><br/>
            <strong>Restricted access</strong>
            <br/><br/>
            Access to certain areas of this website is restricted. [Minusthenegative LLC] reserves the right to restrict access to other areas of this website, or indeed this entire website, at [Minusthenegative LLC] discretion.
            <br/><br/>
            You must ensure that the user ID and password are kept confidential and not shared with any other third party.  
            <br/><br/>
            [Minusthenegative LLC] may disable your user ID and password in [Minusthenegative LLC] sole discretion without notice or explanation.
            <br/><br/>
            <strong>User content</strong>
            <br/><br/>
            In these terms and conditions, “your user content” means material (including without limitation text, images, audio material, video material and audio-visual material) that you submit to this website, for whatever purpose.
            <br/><br/>
            You grant to [Minusthenegative LLC] a worldwide, irrevocable, non-exclusive, royalty-free license to use, reproduce, adapt, publish, translate and distribute your user content in any existing or future media. You also grant to [Minusthenegative LLC] the right to sub-license these rights, and the right to bring an action for infringement of these rights.
            <br/><br/>
            Your user content must not be illegal or unlawful, must not infringe any third party’s legal rights, and must not be capable of giving rise to legal action whether against you or [Minusthenegative LLC] or a third party (in each case under any applicable law).
            <br/><br/>
            You must not submit any user content to the website that is or has ever been the subject of any threatened or actual legal proceedings or other similar complaint.
            <br/><br/>
            [Minusthenegative LLC] reserves the right to edit or remove any material submitted to this website, or stored on [Minusthenegative LLC] servers, or hosted or published upon this website.
            <br/><br/>
            Notwithstanding [Minusthenegative LLC] rights under these terms and conditions in relation to user content, [Minusthenegative LLC] does not undertake to monitor the submission of such content to, or the publication of such content on, this website.
            <br/><br/>
            <strong>No warranties</strong>
            <br/><br/>
            This website is provided “as is” without any representations or warranties, express or implied. [Minusthenegative LLC] makes no representations or warranties in relation to this website or the information and materials provided on this website.
            <br/><br/>
            Without prejudice to the generality of the foregoing paragraph, [Minusthenegative LLC] does not warrant that:
            <br/><br/>
            <ul>
              <li>this website will be constantly available, or available at all; or</li>
              <li>the information on this website is complete, true, accurate or non-misleading.</li>
            </ul>
            <br/>
            Nothing on this website constitutes, or is meant to constitute, advice of any kind. If you require advice in relation to any legal, financial or medical matter you should consult an appropriate professional.
            <br/><br/>
            <strong>Limitations of liability</strong>
            <br/><br/>
            [Minusthenegative LLC] will not be liable to you (whether under the law of contact, the law of torts or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website:
            <br/><br/>
            <ul>
              <li>for any indirect, special or consequential loss; or</li>
              <li>for any business losses, loss of revenue, income, profits or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.</li>
            </ul>
            These limitations of liability apply even if [Minusthenegative LLC] has been expressly advised of the potential loss.
            <br/><br/>
            <strong>Exceptions</strong>
            <br/><br/>
            Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit [Minusthenegative LLC] liability in respect of any:
            <br/><br/>
            <ul>
              <li>death or personal injury caused by [Minusthenegative LLC] negligence;</li>
              <li>fraud or fraudulent misrepresentation on the part of [Minusthenegative LLC]; or</li>
              <li>matter which it would be illegal or unlawful for [Minusthenegative LLC] to exclude or limit, or to attempt or purport to exclude or limit, its liability.</li>
            </ul>
            <strong>Reasonableness</strong>
            <br/><br/>
            By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.
            <br/><br/>
            If you do not think they are reasonable, you must not use this website.
            <br/><br/>
            <strong>Other parties</strong>
            <br/><br/>
            You accept that, as a limited liability entity, [Minusthenegative LLC] has an interest in limiting the personal liability of its officers and employees. You agree that you will not bring any claim personally against [Minusthenegative LLC] officers or employees in respect of any losses you suffer in connection with the website.
            <br/><br/>
            Without prejudice to the foregoing paragraph, you agree that the limitations of warranties and liability set out in this website disclaimer will protect [Minusthenegative LLC] officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as [Minusthenegative LLC].
            <br/><br/>
            <strong>Unenforceable provisions</strong>
            <br/><br/>
            If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, that will not affect the enforceability of the other provisions of this website disclaimer.
            <br/><br/>
            <strong>Indemnity</strong>
            <br/><br/>
            You hereby indemnify [Minusthenegative LLC] and undertake to keep [Minusthenegative LLC] indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by [Minusthenegative LLC] to a third party in settlement of a claim or dispute on the advice of [Minusthenegative LLC] legal advisers) incurred or suffered by [Minusthenegative LLC] arising out of any breach by you of any provision of these terms and conditions, or arising out of any claim that you have breached any provision of these terms and conditions.
            <br/><br/>
            <strong>Breaches of these terms and conditions</strong>
            <br/><br/>
            Without prejudice to [Minusthenegative LLC] other rights under these terms and conditions, if you breach these terms and conditions in any way, [Minusthenegative LLC] may take such action as [Minusthenegative LLC] deems appropriate to deal with the breach, including suspending your access to the website, prohibiting you from accessing the website, blocking computers using your IP address from accessing the website, contacting your internet service provider to request that they block your access to the website and/or bringing court proceedings against you.
            <br/><br/>
            <strong>Variation</strong>
            <br/><br/>
            [Minusthenegative LLC] may revise these terms and conditions from time-to-time. Revised terms and conditions will apply to the use of this website from the date of the publication of the revised terms and conditions on this website. Please check this page regularly to ensure you are familiar with the current version.
            <br/><br/>
            <strong>Assignment</strong>
            <br/><br/>
            [Minusthenegative LLC] may transfer, sub-contract or otherwise deal with [Minusthenegative LLC] rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.
            <br/><br/>
            You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.
            <br/><br/>
            <strong>Severability</strong>
            <br/><br/>
            If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect. If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.
            <br/><br/>
            <strong>Entire agreement</strong>
            <br/><br/>
            These terms and conditions, together with any additional policies on the website,, constitute the entire agreement between you and [Minusthenegative LLC] in relation to your use of this website, and supersede all previous agreements in respect of your use of this website.
            <br/><br/>
            <strong>Law and jurisdiction</strong>
            <br/><br/>
            These terms and conditions will be governed by and construed in accordance with [GOVERNING LAW], and any disputes relating to these terms and conditions will be subject to the [non-]exclusive jurisdiction of the courts of [JURISDICTION].  [USE NJ FOR BOTH]
            <br/><br/>
            <strong>About these website terms and conditions</strong>
            <br/><br/>
            We created these website terms and conditions using a free website terms and conditions form developed by Contractology and available at www.freenetlaw.com. Contractology supply contract templates, including distributor contract forms, to businesses worldwide.
            <br/><br/>
            <strong>Registrations and authorisations</strong>
            <br/><br/>
            [[Minusthenegative LLC] is registered with [TRADE REGISTER]. You can find the online version of the register at [URL]. [Minusthenegative LLC] registration number is [NUMBER].]
            <br/><br/>
            [Minusthenegative LLC] 
            <br/><br/>
            <strong>Details</strong>
            <br/><br/>
            The full name of [Minusthenegative LLC] is [Minusthenegative LLC].
            <br/><br/>
            [Minusthenegative LLC] is registered in New Jersey under registration number [NUMBER].
            <br/><br/>
            [Minusthenegative LLC] registered address is:
            <br/><br/>
            421 Hartung Dr.
            <br/><br/>
            Wyckoff NJ, 07481
            <br/><br/>
            You can contact [Minusthenegative LLC] by email to [response@minusthenegative.com].
          </div>
        );
      case 'privacy':
        return (
          <div className="extra_div">
            <h1>PRIVACY</h1>
            <br/>
            The posts on this site deal with extremely serious subjects, including rape, child abuse, eating disorders, mental illness, and domestic violence. Please take care of yourself while you read them. If you feel as if they’re a trigger, don’t read them.
            <br/><br/>
            Your privacy is pinnacle to us. While you can put your name or social media accounts in your posts, we recommend changing any names for your own safety. Unless there is a situation where someone is at, or could be at harm, we do not divuldge your information. Ever.
          </div>
        );      
      default:
        console.log('default reached in extras');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Extras.js